@if (filtersReady | async) {
	<div>
		<!-- date field -->
		<mat-form-field class="mat-form-field">
			<mat-label>From</mat-label>
			<input matInput [matDatepicker]="frompicker" (dateInput)="OnStartDateChange($event.value)" [value]="filterSettings.startDate" />
			<mat-datepicker-toggle matSuffix [for]="frompicker"></mat-datepicker-toggle>
			<mat-datepicker #frompicker></mat-datepicker>
		</mat-form-field>

		<!-- date field -->
		<mat-form-field class="mat-form-field">
			<mat-label>To</mat-label>
			<input matInput [matDatepicker]="topicker" (dateInput)="OnEndDateChange($event.value)" [value]="filterSettings.endDate" />
			<mat-datepicker-toggle matSuffix [for]="topicker"></mat-datepicker-toggle>
			<mat-datepicker #topicker></mat-datepicker>
		</mat-form-field>

		@if (functionalGroups$ | async; as functionalGroups) {
			<mat-form-field class="mat-form-field">
				<mat-label>Functional group</mat-label>
				<mat-select [value]="filterSettings.functionalGroup" (selectionChange)="onFunctionalGroupChange($event.value)">
					<mat-option [value]="null">All</mat-option>
					@for (group of functionalGroups; track group.uid) {
						<mat-option [value]="group">{{ group.name }}</mat-option>
					}
				</mat-select>
			</mat-form-field>
		}

		@if (groups$ | async; as groups) {
			<mat-form-field class="mat-form-field">
				<mat-label>Group</mat-label>
				<mat-select [value]="filterSettings.group" (selectionChange)="onGroupChange($event.value)">
					<mat-option [value]="null">All</mat-option>
					@for (group of groups; track group.uid) {
						<mat-option [value]="group">{{ group.name }}</mat-option>
					}
				</mat-select>
			</mat-form-field>
		}
	</div>
}
